export function ErrorFallback({ error, resetErrorBoundary }) {
  return (
    <div
      className={`max-w-full break-words flex justify-center items-center flex-col min-h-screen`}
    >
      <img src={`/images/oops.png`} alt={``} className={`w-1/3`} />
      <p className={`font-extrabold text-3xl`}>Something went wrong</p>
      <p className={`font-bold text-center mt-5 border-2 mx-5 p-5`}>
        {error.message}
      </p>
    </div>
  );
}
